module.exports = __webpack_public_path__ + "img/logo_valacon.719cc58c.svg";